import { createFileRoute, Link } from "@tanstack/react-router";
import { useConfigContext } from "@/state/configContext";
import { Fotografos } from "@/helpers/Fotografos";
import { useAppContext } from "@/state/appContext";
import { SelectTemporada } from "@/helpers/SelectTemporada";
import { timeRegexp } from "@/state/types";
import { useState } from "react";
import { clamp } from "@/helpers/helpers";
import { sitioConfig } from "@/sitio";

export const Route = createFileRoute("/_app/")({
  component: Busqueda,
});

function Busqueda() {
  const config = useConfigContext();
  const status = useAppContext();

  const [temporadaId, setTemporadaId] = useState(config.temporada);
  const { minf, maxf } = status.temporadas.find((x) => x.id == temporadaId) || {
    minf: "2099-12-31",
    maxf: "2099-12-31",
  };
  const [fecha_, setFecha] = useState(maxf);
  const [hora, setHora] = useState("");

  const temporada = config.temporadas[temporadaId];
  const fecha = clamp(fecha_, minf, maxf);

  return (
    <div id="buscador">
      <div id="buscadorI">
        <div>
          <SelectTemporada
            temporadas={Object.values(config.temporadas)}
            value={temporadaId}
            onChange={setTemporadaId}
          />
        </div>
        <div className="fecha">
          <input
            type="date"
            value={fecha}
            onChange={(e) => setFecha(e.target.value)}
          />
          &nbsp;
          <input
            name="hora"
            placeholder="HH:MM"
            size={6}
            value={hora}
            onChange={(e) => setHora(e.target.value)}
          />
        </div>
        {
          <Fotografos
            fotografos={temporada.fotografos.filter(
              (x) => x[0] > 0 && (!sitioConfig.local || x[0] < 100)
            )}
            todos={true}
            LinkTo={({ id, children }) => (
              <Link
                to="/buscador"
                search={{
                  t: temporadaId,
                  d: fecha,
                  f: id,
                  ...(hora?.match(timeRegexp) ? { h: hora } : {}),
                }}
              >
                {children}
              </Link>
            )}
          />
        }
      </div>
      <div id="buscadorD" style={{ height: "100%" }} />
    </div>
  );
}
